import React from 'react'
import PropTypes from 'prop-types'
import Card from './Card'
import Slider from 'react-slick'
import _ from 'lodash'

function PrevArrow(props) {
    const { onClick } = props
    return (
        <div className="sk_current-highlights-slider-control-left"
            onClick={onClick}>
            <div className="sk_current-highlights-slider-cotrol-bubble">
                <span className="fa fa-chevron-left"></span>
            </div>
        </div>
    );
}

function NextArrow(props) {
    const { onClick } = props
    return (
        <div className="sk_current-highlights-slider-control-right"
            onClick={onClick}>
            <div className="sk_current-highlights-slider-cotrol-bubble">
                <span className="fa fa-chevron-right"></span>
            </div>
        </div>
    );
}

class CardSlider extends React.Component {
    render() {
        const settings = {
            dots: false,
            slidesToShow: 3,
            slidesToScroll: 3,
            autoplay: true,
            autoplaySpeed: 8000,
            infinite: true,
            nextArrow: <NextArrow />,
            prevArrow: <PrevArrow />,
            responsive: [
                {
                  breakpoint: 992,
                  settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    lazyLoad: false,
                  }
                },
                {
                  breakpoint: 480,
                  settings: {
                    lazyLoad: false,
                    nextArrow: null,
                    prevArrow: null,        
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: false,
                    infinite: false,
                    centerMode: true,
                    centerPadding: '20px',
                  }
                }
          
              ]          
        }

        return (
            <div>
                {
                    this.props.items.length > 3 ? (

                        <Slider {...settings}>
                            {
                                this.props.items.map((item, index) =>
                                    <div key={item.key}>
                                        <Card showButtons={this.props.showButtons} 
                                            cardHeadlineStyle={this.props.cardHeadlineStyle}
                                            image={item.image}
                                            imageLink={item.imageLink}
                                            category={item.category}
                                            headline={item.headline}
                                            headlineLink={item.headlineLink}
                                            subheadline={item.subheadline}
                                            subheadlineLink={item.subheadlineLink}
                                            buttonLink={item.buttonLink}
                                            buttonLabel={item.buttonLabel}
                                            buttonBackgroundImage={item.buttonBackgroundImage} />
                                    </div>
                                )
                            }
                        </Slider>
                    ) : (
                        this.props.items.map((item, index) =>
                            <div key={item.key} className="col-xs-12 col-sm-4 sk_no-padding-sm-min">
                                <Card showButtons={this.props.showButtons} 
                                    cardHeadlineStyle={this.props.cardHeadlineStyle}
                                    image={item.image}
                                    imageLink={item.imageLink}
                                    category={item.category}
                                    headline={item.headline}
                                    headlineLink={item.headlineLink}
                                    subheadline={item.subheadline}
                                    subheadlineLink={item.subheadlineLink}
                                    buttonLink={item.buttonLink}
                                    buttonLabel={item.buttonLabel}
                                    buttonBackgroundImage={item.buttonBackgroundImage} />
                                    <br />
                            </div>
                        )
                    )
                }

            </div>
        );
    }
}

export default CardSlider;